import { render, staticRenderFns } from "./PtRegister.vue?vue&type=template&id=12547431&"
import script from "./PtRegister.vue?vue&type=script&lang=js&"
export * from "./PtRegister.vue?vue&type=script&lang=js&"
import style0 from "./PtRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports